<template>
  <v-toolbar :clipped-left="true" :clipped-right="true" :fixed="true" app>
    <v-toolbar-side-icon
      @click.stop="toggleNavigationDrawerOpen"
    ></v-toolbar-side-icon>
    <router-link :to="{ name: 'home' }">
      <v-toolbar-title class="headline text-uppercase">
        <span>Conveyancing</span>
        <span class="font-weight-light">Tracker</span>
      </v-toolbar-title>
    </router-link>
    <v-spacer></v-spacer>
    <v-tooltip bottom v-if="$keycloak.authenticated">
      <template v-slot:activator="{ on }">
        <v-btn
          flat
          :to="{
            name: 'entity',
            params: { id: $keycloak.tokenParsed.entityid }
          }"
          :color="computedButtonColour"
          v-on="on"
        >
          <v-icon>account_circle</v-icon>
          <span class="mr-2">{{
            nameFormatted($keycloak.tokenParsed.nameRaw, "system")
          }}</span>
        </v-btn>
      </template>
      <span>{{ computedTooltip }}</span>
    </v-tooltip>
    <v-btn
      flat
      v-if="$keycloak.authenticated && $keycloak.hasRealmRole('general')"
      :to="{ name: 'planner' }"
    >
      <v-icon>event</v-icon>
      <span class="mr-2">Planner</span>
    </v-btn>
    <v-btn
      flat
      v-if="$keycloak.authenticated && $keycloak.hasRealmRole('general')"
      @click="openSummary"
    >
      <v-icon>assignment</v-icon>
      <span class="mr-2">Summary</span>
    </v-btn>
    <v-btn flat :to="{ name: 'reports' }" v-if="!$keycloak.authenticated">
      <v-icon>input</v-icon>
      <span class="mr-2">Sign in</span>
    </v-btn>
    <v-btn flat v-if="$keycloak.authenticated" @click="$keycloak.logout">
      <span class="mr-2">sign out</span>
      <v-icon>exit_to_app</v-icon>
    </v-btn>
    <v-dialog
      v-model="dialogSummary"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialogSummary = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <v-icon>assignment</v-icon>Summary
          </v-toolbar-title>
        </v-toolbar>
        <Summary
          :lastUpdated="lastUpdated"
          @navigated="dialogSummary = false"
        />
      </v-card>
    </v-dialog>
  </v-toolbar>
</template>

<script>
import Summary from "@/components/layout/Summary";
import { mapActions } from "vuex";
import { nameFormatted } from "@/util/helpers";
export default {
  name: "Navbar",
  components: { Summary },
  computed: {
    computedButtonColour() {
      return this.autorespond && this.autorespond.active ? "error" : undefined;
    },
    computedTooltip() {
      return this.autorespond && this.autorespond.active
        ? "Your autorespond is active"
        : "Go to your address book entry";
    }
  },
  data() {
    return {
      autorespond: { active: false },
      dialogSummary: false,
      lastUpdated: new Date(),
      first: true
    };
  },
  methods: {
    ...mapActions(["toggleNavigationDrawerOpen"]),
    nameFormatted,
    openSummary() {
      this.lastUpdated = new Date();
      this.dialogSummary = true;
    }
  }
};
</script>
